import React, { useMemo, useState } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { ReportingContainerBaseConfig } from '../../../../base';
import {
    SnippetInputLabelController,
    SnippetInputLabelLoader,
} from './snippetLabelInterface';
import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';
import {
    SnippetInputLabelContainerProps,
    SnippetInputLabelViewProps,
} from './snippetLabelProps';
import { assertNever } from '@varos/util-typescript';
import { SnippetLabelAggregate } from './snippetLabelModel';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

export function createSnippetInputLabelContainer(
    config: ReportingContainerBaseConfig,
    loader: SnippetInputLabelLoader,
    controller: SnippetInputLabelController
): React.FC<SnippetInputLabelContainerProps> {
    const {
        context: { useContext },
        repository: { research: repository },
    } = config;

    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, {
            snippet: containerProps.snippet,
        });
        const props = controller.useProps(context, data, {
            disclosure: useDisclosure({
                onOpen: containerProps.onOpen,
            }),
        });
        return <View {...props} />;
    };
}
